import { FC } from "react";
import { Switch } from "@headlessui/react";
import { ISwitchProps } from "./types";

const SwitchComponent: FC<ISwitchProps> = ({ checked, onChange, invert }) => (
  <Switch
    checked={checked}
    onChange={onChange}
    className={`${
      invert ? "bg-inverseMenuBackground" : "bg-headerBackground"
    } flex h-3 w-9 items-center rounded-full pr-6 pt-2 pb-2`}
  >
    <span
      className={`${checked ? "translate-x-1" : "translate-x-5"} h-3 w-3 transform rounded-full ${
        invert ? "bg-headerBackground" : "bg-inverseMenuBackground"
      } transition`}
    />
  </Switch>
);

export default SwitchComponent;
